<template>
  <dropdown
    class="settings"
    :visible="visible"
    animation="ani-fade"
    :position="['right', 'bottom', 'right', 'top']"
    @clickout="visible=false">
    <button class="link"  @click="visible=true">
      <div class="settings__icon">
        {{ $t('explorer.optionsDropdown') }}
      </div>
      <div class="trigger">
        <font-awesome-icon :icon="icon.angleDown" />
      </div>
    </button>
    <div slot="dropdown" class="dialog">
      <ul class="dialog__list">
        <li v-if="variableAmount === 2">
          <span
            href="#"
            class="dialog__item clickable"
            @click="singleAxis">
            <checkbox
              check-size="xs"
              class="option-checkbox"
              :checked="singleAxisChecked"/>
            <span class="dialog__item-text">{{ $t('explorer.evolutionOptions.singleAxis') }}</span>
          </span>
        </li>
        <li>
          <span
            href="#"
            class="dialog__item clickable"
            @click="gridStateChange">
            <checkbox
              check-size="xs"
              class="option-checkbox"
              :checked="gridVisibleChecked"/>
            <span class="dialog__item-text">{{ $t('explorer.evolutionOptions.gridVisibleChecked') }}</span>
          </span>
        </li>
        <li>
          <span
            href="#"
            class="dialog__item clickable"
            @click="showPointsStateChange">
            <checkbox
              check-size="xs"
              class="option-checkbox"
              :checked="showPoints"/>
            <span class="dialog__item-text">{{ $t('explorer.evolutionOptions.showPoints') }}</span>
          </span>
        </li>
        <li>
          <span
            href="#"
            class="dialog__item clickable"
            @click="fixedAxes">
            <font-awesome-icon class="dialog__category-icon" :icon="icon.arrows" />
            <span class="dialog__item-text">{{ $t('explorer.evolutionOptions.fixedAxes') }}</span>
          </span>
        </li>
        <li v-if="variableAmount === 2 || variableAmount === 3">
          <span
            href="#"
            class="dialog__item clickable"
            @click="toCorrelation">
            <font-awesome-icon class="dialog__category-icon" :icon="icon.scatter" />
            <span class="dialog__item-text">{{ $t('explorer.evolutionOptions.toCorrelation') }}</span>
          </span>
        </li>
      </ul>
    </div>
  </dropdown>
</template>

<script>
import dropdown from 'vue-my-dropdown';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faAngleDown, faArrowsAltV } from '@fortawesome/fontawesome-free-solid';
import { faChartArea } from '@fortawesome/pro-light-svg-icons';
import checkbox from '@/components/shared/forms/Checkbox';

export default {
  name: 'OptionsEvolution',
  components: {
    dropdown,
    FontAwesomeIcon,
    checkbox
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      icon: {
        angleDown: faAngleDown,
        arrows: faArrowsAltV,
        scatter: faChartArea
      },
      visible: false,
      singleAxisChecked: true,
      variableAmount: 0,
      gridVisibleChecked: false,
      showPoints: false
    };
  },
  watch: {
    data: {
      handler () {
        const variables = this.data.variables;

        if (variables) {
          this.variableAmount = variables.length;
        } else {
          this.variableAmount = 0;
        }
      },
      deep: true
    }
  },
  methods: {
    setSingleAxis (singleAxisStatus) {
      this.singleAxisChecked = singleAxisStatus;
    },
    setGridVisible (gridVisible) {
      this.gridVisibleChecked = gridVisible;
    },
    setShowPoints (showPoints) {
      this.showPoints = showPoints;
    },
    fixedAxes () {
      this.visible = false;
      this.$emit('onFixedAxes');
    },
    singleAxis () {
      this.visible = false;
      this.singleAxisChecked = !this.singleAxisChecked;
      this.$emit('onSingleAxis', this.singleAxisChecked);
    },
    gridStateChange () {
      this.gridVisibleChecked = !this.gridVisibleChecked;
      this.visible = false;

      setTimeout(() => {
        this.$emit('onGridStateChange', this.gridVisibleChecked);
      });
    },
    showPointsStateChange (e) {
      this.showPoints = !this.showPoints;
      this.visible = false;

      setTimeout(() => {
        this.$emit('onShowPointsChange', this.showPoints);
      });
    },
    toCorrelation () {
      this.visible = false;
      this.$emit('onCorrelation');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

.settings {
  margin-left: auto;
  .link {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: 0;
    color: inherit;
    &:hover,
    &:focus {
      opacity: 0.75;
      cursor: pointer;
      outline: 0;
    }
  }
  &__icon {
    margin-right: $sp;
  }
  .trigger svg {
    transform: scale(0.875);
    transform-origin: bottom;
  }

  .clickable {
    cursor: pointer;
  }

  .option-checkbox {
    margin-bottom: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/explorer/evolution/OptionsEvolution.vue